import cls from "classnames"
import React from "react"
import * as styles from "./index.module.scss"
import { RETURN_BUTTON_KEY, STORAGE_KEY } from "@/constants/common"
import { navigate } from "@reach/router"
import Icon from "../icon"
import {Link} from "gatsby";

const ReturnButton = (props: { pageKey: RETURN_BUTTON_KEY }) => {
  const getContainerProps = (key: RETURN_BUTTON_KEY) => {
    const onClick = {
      [RETURN_BUTTON_KEY.CASE]: {
        className: styles.caseReturnBtn,
        to: `/case?industry=${(typeof window !== "undefined" && sessionStorage.getItem(STORAGE_KEY.INDUSTRY)) ?? "all"}&scene=${(typeof window !== "undefined" && sessionStorage.getItem(STORAGE_KEY.SCENE)) ?? "all"}`,
      },
      [RETURN_BUTTON_KEY.BLOG]: {
        className: styles.blogReturnBtn,
        to: (typeof window !== "undefined" && (sessionStorage.getItem(STORAGE_KEY.BLOG_TAG) ? `/blog/?tag=${sessionStorage.getItem(STORAGE_KEY.BLOG_TAG)}` : (sessionStorage.getItem(STORAGE_KEY.BLOG_CATEGORY) ? `/blog/categories/${sessionStorage.getItem(STORAGE_KEY.BLOG_CATEGORY)}` : "/blog"))),
      },
      [RETURN_BUTTON_KEY.JOINT_SOLUTION]: {
        className: styles.lowerReturnBtn,
        to: (typeof window !== "undefined" && window.location.href.includes("joint-solution")) ? "/joint-solution" : "/about-us/?tab=news",
      },
      [RETURN_BUTTON_KEY.BEST_PRACTICE]: {
        to: `/practice?tag=${(typeof window !== "undefined" && sessionStorage.getItem(STORAGE_KEY.PRACTICE)) ?? "全部"}`,
      },
      [RETURN_BUTTON_KEY.SOLUTION]: {
        to: `/solution?category=${(typeof window !== "undefined" && sessionStorage.getItem(STORAGE_KEY.SOLUTION)) ?? "行业解决方案"}`,
      },
      [RETURN_BUTTON_KEY.INSIGHT]: {
        to: "/insight",
      },
    }
    return onClick[key]
  }

  return (
    <Link
      className={styles.normalReturnBtn}
      {...getContainerProps(props.pageKey)}
    >
      <Icon name="arrow-right" />
      <label>返回全部</label>
    </Link>
  )
}

export default ReturnButton
